// import assest from "@/json/assest";
import assest from "../../json/assest";
import React from "react";
import styles from "../../styles/pages/home.module.scss";
import styles1 from "../../styles/components/emptyTable.module.scss";
import styles2 from "../../styles/components/ClearedPageTable/clearedTable.module.scss";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import RingroundIcon from "../../public/assets/icons/RingroundIcon";
// import Pagination from "@/components/UtilitiesComponent/Pagination";
// import FilterModal from "@/components/FilterModal/FilterModal";
// import AllPurchasedFilterModal from "@/components/FilterModal/AllPurchasedFilterModal";
// import { EmploymentType } from "next-seo/lib/jsonld/jobPosting";

const EmptyTable = (props) => {
  const { hideApprovedTab, approvedTabName, filterRowProps, emptyTableText } =
    props;

  // console.warn(emptyTableText, "emptyTableTextooooo");

  return (
    //   <Box className={styles.table_sec}>
    //     <Box className={styles.table_top}>
    //       <FilterRow
    //         {...filterRowProps}
    //         FilterModalComponent={AllPurchasedFilterModal}
    //         filterModalProps={{
    //           hideBottom: true,
    //         }}
    //       />
    //     </Box>
    //   <Box className={styles.table_main}>
    //     <Box className={styles1.emptyTable}>
    //       <Box className={styles1.emptyTableImg}>
    //         <img src={assest.emptyImg} width={18} height={18} alt="" />
    //         <Box className={styles1.emptyLine}></Box>
    //       </Box>

    //       {emptyTableText.length === 3 ? (
    //         <p>
    //           {emptyTableText?.[0]} <br></br> {emptyTableText?.[1]}
    //         </p>
    //       ) : (
    //         <p>{emptyTableText}</p>
    //       )}
    //     </Box>
    //   </Box>
    // </Box>
    <Box className={`${styles1.emptyTable} emptyTableParents`}>
      <Box
        className={`${styles1.emptyTableImg} ${styles2.emptyTableImgpublish} ${styles1.emptyTableImgPartner} emptyTableImgMain`}
      >
        <RingroundIcon />
      </Box>

      {emptyTableText.length === 3 ? (
        <p>
          {emptyTableText?.[0]} <br></br> {emptyTableText?.[1]}
        </p>
      ) : (
        <p>{emptyTableText}</p>
      )}
    </Box>
  );
};

export default EmptyTable;
